module.exports = __webpack_public_path__ + "static/img/burlington2.dbb9af9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/burlington2.jpg
// module id = 73
// module chunks = 9